import { Component, computed, inject, signal, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { selectAutoCreateMosDeviceItems } from '@src/suite/live/store/selectors/live.selectors';

import { ComboBoxComponent } from '../../controls/combo-box/combo-box';
import { TextFieldComponent } from '../../controls/text-field/text-field';

@Component({
    selector: 'st-object-placeholder-create',
    imports: [ComboBoxComponent, MatButtonModule, MatIconModule, TextFieldComponent],
    templateUrl: './object-placeholder-create.html',
    styleUrl: './object-placeholder-create.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-object-placeholder-create',
    },
})
export class ObjectPlaceholderCreateComponent {
    private store = inject(Store);
    private dialogRef = inject(MatDialogRef<ObjectPlaceholderCreateComponent>);

    languageSettings = this.store.selectSignal(selectI18N);
    autoCreateMosDeviceItems = this.store.selectSignal(selectAutoCreateMosDeviceItems)();

    readonly mosObjectPlaceholder = signal<{ device: string; group: string; type: string; slug: string }>({
        device: '',
        group: '',
        type: '',
        slug: '',
    });

    readonly mosTypes = computed(() => {
        return [
            { id: '', title: '' },
            { id: this.languageSettings()?.OPCAudioContentLabel, title: this.languageSettings()?.OPCAudioContentLabel },
            { id: this.languageSettings()?.OPCStillContentLabel, title: this.languageSettings()?.OPCStillContentLabel },
            { id: this.languageSettings()?.OPCVideoContentLabel, title: this.languageSettings()?.OPCVideoContentLabel },
        ];
    });
    readonly mosGroupCbItems = computed(() => {
        return this.autoCreateMosDeviceItems[this.mosObjectPlaceholder().device]?.definedGroups?.map(g => ({ id: g, title: g }));
    });

    readonly canSave = computed(() => {
        return this.mosObjectPlaceholder().device !== '' && this.mosObjectPlaceholder().type !== '' && this.mosObjectPlaceholder().slug !== '';
    });

    onMosTypeChanged(event: { id: string; title: string }) {
        this.mosObjectPlaceholder.set({ ...this.mosObjectPlaceholder(), type: event.id });
    }

    onDeviceChanged(event: { id: string }) {
        this.mosObjectPlaceholder.set({ ...this.mosObjectPlaceholder(), device: event.id });
    }

    onGroupChanged(event: string) {
        this.mosObjectPlaceholder.set({ ...this.mosObjectPlaceholder(), group: event });
    }

    onSlugChanged(event: string) {
        this.mosObjectPlaceholder.set({ ...this.mosObjectPlaceholder(), slug: event });
    }

    cancelPlaceholderCreate() {
        this.mosObjectPlaceholder.set({
            device: '',
            group: '',
            type: '',
            slug: '',
        });
        this.dialogRef.close();
    }

    createPlaceholder() {
        const mosObjectPlaceholder = `${this.mosObjectPlaceholder().device};${this.mosObjectPlaceholder().group};${this.mosObjectPlaceholder().type};${this.mosObjectPlaceholder().slug}`;
        this.dialogRef.close({ mosObjectPlaceholder });
    }
}
